import { forwardRef, type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'
import { MessagesSquare } from 'lucide-react'

/** Icon tile over a title and a line of help. The root places nothing around itself; callers pad it. */
const EmptyState = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={twMerge('flex w-full flex-1 flex-col items-center justify-center gap-1 text-center', className)}
    {...props}
  />
))
EmptyState.displayName = 'EmptyState'

const EmptyStateIcon = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    aria-hidden="true"
    className={twMerge(
      'bg-background-raised text-foreground-secondary corner-smooth shadow-xs mb-3 flex size-12 items-center justify-center rounded-xl [&_svg]:size-5',
      className,
    )}
    {...props}
  />
))
EmptyStateIcon.displayName = 'EmptyStateIcon'

const EmptyStateTitle = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={twMerge('text-foreground type-ui-md max-w-72 text-balance font-semibold', className)}
      {...props}
    />
  ),
)
EmptyStateTitle.displayName = 'EmptyStateTitle'

const EmptyStateDescription = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={twMerge('text-foreground-secondary type-ui-sm max-w-72 text-balance', className)}
      {...props}
    />
  ),
)
EmptyStateDescription.displayName = 'EmptyStateDescription'

function TranscriptEmptyState() {
  return (
    <EmptyState className="px-5 py-10">
      <EmptyStateIcon>
        <MessagesSquare />
      </EmptyStateIcon>
      <EmptyStateTitle>No transcript</EmptyStateTitle>
      <EmptyStateDescription>Nothing was transcribed for this meeting.</EmptyStateDescription>
    </EmptyState>
  )
}

export { EmptyState, EmptyStateIcon, EmptyStateTitle, EmptyStateDescription, TranscriptEmptyState }
